import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/awards.json";

export const useAwards = () => useSourceFlowCollection(data);

export default useAwards;
